import { ref } from 'vue';
import { defineStore } from 'pinia';
import { createStorage } from '@aviata/storage';
import { createContactsData, type ContactsData } from '@aviata/booking-data';

export const useContactsStore = defineStore('contacts-data', () => {
  const contactsStorage = createContactsData(
    createStorage(localStorage),
    'free-avia:contacts-v1',
  );
  /**
   * @property {string} phone - is in format '+7 xxx xxx xx xx'. Need to remove phone code before booking request.
   * @property {string} phoneCode - is always '+7' since backend don't support other phone codes yet.
   * */
  const state = ref<ContactsData>(contactsStorage.init());

  const updateState = (newData: Partial<ContactsData>) => {
    const updatedState = { ...state.value, ...newData };
    state.value = updatedState;
    contactsStorage.save(updatedState);
  };

  const isContactsEmpty = () => {
    return state.value.email === '' && state.value.phone === '';
  };

  return {
    state,
    updateState,
    isContactsEmpty,
  };
});
